import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import HomePage from "@/pages/HomePage";
import CreateTripPage from "@/pages/CreateTripPage";
import TripPage from "@/pages/TripPage";
import LoginPage from "@/pages/LoginPage";
import MyTripsPage from "@/pages/MyTripsPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/trip/:tripId" element={<TripPage />} />
          <Route path="/" element={<HomePage />} />
          <Route path="/create" element={<ProtectedRoute><CreateTripPage /></ProtectedRoute>} />
          <Route path="/my-trips" element={<ProtectedRoute><MyTripsPage /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;